<script setup>
import { computed } from 'vue';

const props = defineProps({
  startHour: { type: Number, required: true },
  endHour: { type: Number, required: true },
  pixelsPerHour: { type: Number, default: 60 },
});

const hours = computed(() => {
  const result = [];
  for (let h = props.startHour; h <= props.endHour; h += 1) {
    result.push({ h, label: `${String(h).padStart(2, '0')}:00` });
  }
  return result;
});

const currentHour = computed(() => new Date().getHours());
</script>

<template>
  <div
    class="w-[60px] shrink-0 border-r border-n-slate-3 bg-n-surface-1 text-[10px] text-n-slate-10"
  >
    <div
      v-for="entry in hours"
      :key="entry.h"
      :style="{ height: `${pixelsPerHour}px` }"
      class="px-2 py-1 text-right tabular-nums"
      :class="entry.h === currentHour ? 'font-semibold text-n-ruby-9' : ''"
    >
      {{ entry.label }}
    </div>
  </div>
</template>
